<template>
  <div class="error-msg">
    <img class="mr-3" src="../../../assets/DefaultCloudzet/basic-confused.svg" />
    <span class="text-xs">{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: {
    message: String,
  },
};
</script>

<style scoped>
.error-msg {
  @apply mt-5 h-5 flex justify-center w-full;
  color: #d12c2d;
}
</style>
